// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import Api from './services/ApiService'
import EventBus from './services/EventBus'

// Filters are directly applied to Vue Instance
import Filters from './services/VueFilters'


Vue.config.productionTip = false;

// Prototypes
Vue.prototype.$api = Api;
Vue.prototype.$bus = EventBus;


// Extensions
import VueSocketIo from 'vue-socket.io';
Vue.use(new VueSocketIo({
    debug: false,
    connection: process.env.SOCKET_URL
}));

import VueSweetAlert from 'vue-sweetalert';
Vue.use(VueSweetAlert);

import FontAwesomeIcon from './services/Icons';
Vue.component('fa-icon', FontAwesomeIcon);



new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js